'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 *
 */
var ADD = exports.ADD = 'vtech-chat/chats/ADD';
var SET_ACTIVE_DISCUSSION = exports.SET_ACTIVE_DISCUSSION = 'vtech-chat/chats/SET_ACTIVE_DISCUSSION';
var SUBSCRIBE = exports.SUBSCRIBE = 'vtech-chat/chats/SUBSCRIBE';

/**
 *	Adds a chat to the store.
 */
var add = exports.add = function add(chat) {
	return {
		type: ADD,
		payload: {
			chat: chat
		}
	};
};

/**
 *
 */
var setActiveDiscussion = exports.setActiveDiscussion = function setActiveDiscussion(id, discussionId) {
	return {
		type: SET_ACTIVE_DISCUSSION,
		payload: {
			id: id,
			discussionId: discussionId
		}
	};
};

/**
 *
 */
var subscribe = exports.subscribe = function subscribe(id) {
	return {
		type: SUBSCRIBE,
		payload: {
			id: id
		}
	};
};